var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H5.5C2.73858 0 0.5 2.23858 0.5 5V27C0.5 29.7614 2.73858 32 5.5 32H27.5C30.2614 32 32.5 29.7614 32.5 27V5C32.5 2.23858 30.2614 0 27.5 0Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11C23.9 11.3 23.3 11.4 22.6 11.5C23.3 11.1 23.8 10.5 24 9.7C23.4 10.1 22.7 10.3 21.9 10.5C21.3 9.9 20.4 9.5 19.5 9.5C17.4 9.5 15.8 11.5 16.3 13.5C13.6 13.4 11.2 12.1 9.5 10.1C8.6 11.6 9.1 13.5 10.5 14.5C10 14.5 9.5 14.3 9 14.1C9 15.6 10.1 17 11.6 17.4C11.1 17.5 10.6 17.6 10.1 17.5C10.5 18.8 11.7 19.8 13.2 19.8C12 20.7 10.2 21.2 8.5 21C10 21.9 11.7 22.5 13.5 22.5C19.6 22.5 23 17.4 22.8 12.7C23.5 12.3 24.1 11.7 24.5 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cce7e1d744b2155f71f3907a46aae90e.svg";
export { ForwardRef as ReactComponent };